import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { NavLink, Link, useHistory } from "react-router-dom";
import Select from "react-select";
import { AxiosCustomGet } from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";

import SwalToast from "../../../../components/helpers/SwalToast";
import AppRoutePath from "../../../../router/AppRoutePath";
import { PermissionContext } from "../../../../components/context/PermissionContext";
import { TiUser } from "react-icons/ti";
import Title from "../../../../components/common/Title/Title";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../components/template/authorization/Authorization";
import { Button } from "antd";
import httpclient from "../../../../components/httpclient";
import { initFilterInput, renderColumns } from "../constants";
import { convertListNotification } from "./helpers/convertListNotification";
import CustomTable from "../../../../components/common/Table/CustomTable";
import Swal from "sweetalert2";

export default function NotificationSettingList() {
  const [loading, setLoading] = useState(false);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [records, setRecords] = useState([]);
  const [tablePagination, setTablePagination] = useState({});

  useEffect(() => {
    getData();
  }, [filterInput]);

  const getData = () => {
    setLoading(true);
    let params = {
      search: filterInput.searchName,
      page: filterInput.page,
      page_size: filterInput.pageSize,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}notification-group`;
    httpclient
      .GET(url, params)
      .then((response) => {
        setRecords(convertListNotification(response.data.data.items));
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      })
      .finally(() => setLoading(false));
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      sortBy: sorter?.column?.backend_key || null,
      orderBy:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
          ? "DESC"
          : null,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleDelete = (record) => {
    let url = `${process.env.REACT_APP_BASE_API_URL}notification-group/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus notifikasi " + record.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2C465C",
      cancelButtonColor: "#F23434",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          });
      }
    });
  };

  return (
    <div>
      <div className="p-3">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="">
            <Title text="Notifikasi Jatuh Tempo" />
            <Breadcrumb current="Notifikasi Jatuh Tempo" />
          </div>
          <div
            style={{
              padding: 13,
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              height: 50,
              width: 222,
            }}
          >
            <div
              style={{
                fontSize: 18,
                color: "#303030",
              }}
            >
              <TiUser
                style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
              />
              <span style={{ fontWeight: 700 }}>{tablePagination.total}</span>{" "}
              Total Notifikasi
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: 20,
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div className="d-flex" style={{ flex: 4 }}>
            <div className="mt-3 col-4 pl-0">
              <label htmlFor="search_name" className="">
                Nama Notifikasi :
              </label>
              <input
                name="name"
                id="search_name"
                type="text"
                className="form-control border-97A0AE"
                placeholder="Nama Notifikasi"
              />
            </div>
          </div>
          <div style={{ flex: 2, display: "flex", justifyContent: "flex-end" }}>
            <CanAccess
              role={AuthorizationList.create_notification_group}
              yes={
                <Link to={AppRoutePath.ADD_NOTIFICATION}>
                  <Button
                    style={{
                      alignSelf: "flex-end",
                      height: 36,
                      background: "#2C465C",
                      color: "#FFF",
                      width: 180,
                      borderRadius: 6,
                    }}
                  >
                    + Tambah Notifikasi
                  </Button>
                </Link>
              }
            />
          </div>
        </div>
        <div className="mt-3">
          <CustomTable
            columns={renderColumns(handleDelete)}
            data={records}
            loading={loading}
            handleTableChange={handleTableChange}
            pagination={tablePagination}
          />
        </div>
      </div>
    </div>
  );
}
